import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=63f58d5f&"
import script from "./quotation.vue?vue&type=script&lang=ts&"
export * from "./quotation.vue?vue&type=script&lang=ts&"
import style0 from "./quotation.vue?vue&type=style&index=0&id=63f58d5f&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports